import { Component, Input, OnInit } from '@angular/core';
import { RentalsUnitedService } from '../..';
import { first } from 'rxjs/operators';
import { AuthenticationService, UserService } from '@app/_services';
import { PropertyService } from '@app/_components/property';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ReportService } from '@app/_components/report';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ApiResponse } from '@app/_models';

@Component({
    selector: 'app-ru-property',
    templateUrl: './ru-property.component.html',
    styleUrls: ['./ru-property.component.css'],
    standalone: false
})
export class RuPropertyComponent implements OnInit {

	selectedShortTermRental: any;
	ruProperties: any[]=[];
	shortTermRentals: any = [];

	// data
	apiResponse: ApiResponse;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;
	formErrorMessage: String;
	rowCounter = 0;
	syncShortNameFlag = false

	validationMessages = {
		'shortTermRentalId': [],
		'addressDevelopmentName': [],
		ruAccount:[]
	};
	ruAccounts: any[];

	@Input() ruAccount: any;

	constructor(
		private rentalsUnitedService: RentalsUnitedService,
		private authenticationService: AuthenticationService,
		private userService: UserService,
		private propertyService: PropertyService,
		private router: Router,
		private messageService: MessageService,
		private route: ActivatedRoute,
		private reportService: ReportService,
		private activatedRoute: ActivatedRoute,
		private formBuilder: UntypedFormBuilder) 
		{
			this.ruAccounts = rentalsUnitedService.ruAccounts;
		 }



	ngOnInit(): void {
		this.buildForm();
		
		if(this.ruAccount != undefined){
			const data ={
				ruAccount: this.ruAccount,
				syncShortName: this.syncShortNameFlag
				
			}
				this.ruAccount = this.ruAccount;
			this.loadRuProperties(data);
		}else{
			const data ={
				ruAccount: this.form1.value.ruAccount,
				syncShortName: this.syncShortNameFlag
			}
				this.ruAccount = this.form1.value.ruAccount	
			this.loadRuProperties(data);
		}
		this.loadShortTermRentals();
	}

	onRUAccount(event)
  {
    // console.log('shortTermRentalSummary ' + JSON.stringify(event.value));
    this.ruAccount = event.value;
    this.ngOnChanges();
  }

  ngOnChanges() {
		
	this.ngOnInit();
}

	onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		if(this.ruAccount != undefined){
			const data ={
				shortTermRentalId: this.form1.value.shortTermRentalId,
				ruAccount: this.ruAccount,
				syncShortName: this.syncShortNameFlag,
			}
			this.saveRuProperty(data);
		}else{
			const data ={
				shortTermRentalId: this.form1.value.shortTermRentalId,
				ruAccount: this.form1.value.ruAccount,
				syncShortName: this.syncShortNameFlag
			}
			this.saveRuProperty(data);
		}
		
	}
	
	loadRuProperties(data: any) {
		this.formLoading = true;
		this.rentalsUnitedService.listProperties(data)
			.pipe(first())
			.subscribe(
				res => {
					console.log('loadRuProperties: ' + JSON.stringify(res));
					this.ruProperties = [...res.data.properties.Properties];
					console.log('loadRuProperties OK: ' + JSON.stringify(this.ruProperties));
				},
				err => {
					console.log('error In login.component is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'loadRuProperties Failed', detail: 'We were unable to retrieve your RuProperties: ' + err.message, life: 3000 });
				},
				() => { this.formLoading = false; });
	}


	saveRuProperty(property: any) {
		this.formLoading = true;
		this.rentalsUnitedService.saveProperty(property)
			.pipe(first())
			.subscribe(
				res => {
					console.log('saveRuProperty: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Saved', detail: '' + res.message, sticky: false });
					if(this.ruAccount != undefined){
						const data ={
							ruAccount: this.ruAccount,
							syncShortName: this.syncShortNameFlag
						}
						this.ruProperties = [];
						this.loadRuProperties(data);
					}else{
						const data ={
							ruAccount: this.form1.value.ruAccount,
							syncShortName: this.syncShortNameFlag
						}
						this.ruProperties = [];
						this.loadRuProperties(data);
					}
				},
				err => {
					console.log('error In login.component is: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'saveRuProperty Failed', detail: 'We were unable to save : ' + err, life: 3000 });
				},
				() => { this.formLoading = false; });
	}


	onSaveAllPropertiesClick() {
		if(this.ruAccount != undefined){
			const data ={
				ruAccount: this.ruAccount,
				syncShortName: this.syncShortNameFlag,
			}
			this.saveAllRuProperties(data);
		}else{
			const data ={
				ruAccount: this.form1.value.ruAccount,
				syncShortName: this.syncShortNameFlag
			}
			this.saveAllRuProperties(data);
		}
		
	}
	
	saveAllRuProperties(property: any) {
		this.formLoading = true;
		this.rentalsUnitedService.saveAllRuProperties(property)
			.pipe(first())
			.subscribe(
				res => {
					this.loadRuProperties(this.ruAccount);
					console.log('saveRuProperty: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Saved All RU Properties', detail: '' + res.message, life: 3000 });
					this.loadRuProperties(this.ruAccount);
				},
				err => {
					console.log('error In login.component is: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'saveRuProperty Failed', detail: 'We were unable to save all RU Properties: ' + err, life: 3000 });
				},
				() => { this.formLoading = false; });
	}


	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList()
			.subscribe(
				res => {
					// console.log('loadShortTermRentals SUCCESS: ' + JSON.stringify(res.data.propertySummaryList));
					this.shortTermRentals = res.data.propertySummaryList;
					this.shortTermRentals.unshift({});
				},
				err => {
					console.log('loadShortTermRentals FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'loadShortTermRentals Failed', detail: 'We were unable to retrieve your shortTermRentals: ' + err.message, sticky: false });
				},
				() => { this.formLoading = false; });
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			shortTermRentalId: ['', Validators.required],
			ruAccount:["test"],
			syncShortName:[]
		});
	}

	syncShortNameChange(event: any){
		this.syncShortNameFlag = event.checked;
	}
}
